import { useEffect, useState } from "react";

import { Text, Modal } from "$components";
import useJStyles from "$hooks/useJStyles";

type EDBPopinProps = {
  product: any;
  resetProduct: () => void;
  validateDeleteProduct: (productId: string, edbId: string) => void;
  idEdb: string;
};

function ModalDeleteProduct({
  product,
  resetProduct,
  validateDeleteProduct,
  idEdb,
}: EDBPopinProps) {
  const { jclasses } = useJStyles();
  const [openPopin, setOpenPopin] = useState(false);

  useEffect(() => {
    setOpenPopin(product !== null);
  }, [product]);

  const togglePopin = (open: boolean) => {
    setOpenPopin(open);
    resetProduct();
  };

  const validate = () => {
    validateDeleteProduct(product._id, idEdb);
    togglePopin(false);
  };

  return (
    <Modal
      textValidate="Supprimer"
      textCancel="Annuler"
      open={openPopin}
      onValidate={validate}
      onCancel={() => togglePopin(false)}
    >
      <div className={jclasses.jDialogContent}>
        <Text>
          Attention
          <br />
          Vous êtes sur le point de supprimer le produit {product?.reference}
          {" - "}
          {product?.designation} de l’EDB. Le produit sera supprimé
          définitivement sur cette vue et sur l’onglet “Besoin matériel”.
          <br />
          Êtes-vous sûr de vouloir continuer ?
        </Text>
      </div>
    </Modal>
  );
}

export default ModalDeleteProduct;
